import React, {useState} from 'react';

import '../Tutorial.css';
import Typewriter from "typewriter-effect";
import TutorialGirl from "../TutorialGirl";
import {useActions} from "../../../hooks/useActions";

function T230ArenaSeasonProgress() {



    const [showNext, setShowNext] = useState(false);
    const {setTutorial} = useActions();

    const text = 'Climb through the Season Rewards and earn Gems, Soul Stones, Divine Essence, and powerful cards.';

    const atEnd = () =>{
        setShowNext(true);
    }

    return <div>

        <div className={'T200Left'}></div>
        <div className={'T200Right'}></div>
        <div className={'T150Bottom'}></div>

        <TutorialGirl position={'Left'} undressingProcess={3}/>
        <div className='tutorialContainer tutorialTopContainer230'>
            <div className='tutorialBottomTextField'>
                <Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start().callFunction(atEnd);
                    }}
                />
            </div>
            {(showNext)?
                <div className={'tutorialButton defaultButtonAnimation'} onClick={() => {
                    setTutorial({isActive: true, step: 'ArenaFinish240'});
                }}>
                </div>
                : <div className={'tutorialButtonPlaceholder'}></div>
            }
        </div>
    </div>
}

export default T230ArenaSeasonProgress;